module.exports = __webpack_public_path__ + "static/media/glaux-1.7d8e9ca5.png";